import React from 'react'
import { T } from '@transifex/react'

import { createRoutesMapWarehouseManagementRouter } from './warehouses'
import { pathJoin } from '../../../utils'

export const createRoutesMapInventory = (prefix: string) => ({
  warehouses: pathJoin(prefix)('warehouses').chainMapAuto(
    createRoutesMapWarehouseManagementRouter,
    {
      title: <T _str="All Warehouses" />,
      breadCrumbTitle: <T _str="All Warehouses" />,
    }
  ),
  overview: pathJoin(prefix)('overview').chainWithTitle({
    title: <T _str="Stock overview" />,
    breadCrumbTitle: <T _str="Stock overview" />,
  }),
  // PRO-252: the dedicated Spare-parts stock presentation. A parallel surface
  // on `development`; at integration with PRO-211-FE it folds into that
  // overview's Kind=SPARE_PART segment and this entry is dropped.
  'spare-parts': pathJoin(prefix)('spare-parts').chainWithTitle({
    title: <T _str="Spare parts" />,
    breadCrumbTitle: <T _str="Spare parts" />,
  }),
})
